import { createRouter, createWebHistory } from "vue-router";
import { usePostHog } from '@/composables/usePostHog';
import Layout from "@/layouts";

import Home from "../views/Home.vue";

import CollectionAll from "@/views/Collections/All.vue";

import Advertisements from "../views/Advertisements/index.vue";
import AdvertisementsInvisible from "../views/Advertisements/Invisible.vue";
import AdvertisementsNew from "../views/Advertisements/new.vue";
import AdvertisementsEdit from "@/views/Advertisements/Edit.vue";

import Tiktoks from "../views/Tiktoks/index.vue";
import TiktoksNew from "../views/Tiktoks/new.vue";
import TiktoksEdit from "../views/Tiktoks/edit.vue";
import TitlesSubtitles from "../views/TitlesSubtitles/index.vue";
import TitlesSubtitlesEdit from "../views/TitlesSubtitles/edit.vue";
import Pricing from "../views/Pricing/index.vue";
import PricingEdit from "../views/Pricing/edit.vue";
import UGCCReators from "../views/UGCCreators/index.vue";
import UGCCreatorsEdit from "../views/UGCCreators/edit.vue";
import UGCCreatorsNew from "../views/UGCCreators/new.vue"
const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/collections",
    name: "CollectionsLayout",
    component: Layout,
    children: [
      {
        path: "/collections/",
        name: "CollectionsAll",
        component: CollectionAll,
      },
    ],
  },
  {
    path: "/advertisements",
    name: "AdvertisementsLayout",
    component: Layout,
    children: [
      {
        path: "/advertisements/",
        name: "Advertisements",
        component: Advertisements,
      },
      {
        path: "/advertisements/invisible",
        name: "AdvertisementsInvisible",
        component: AdvertisementsInvisible,
      },
      {
        path: "/advertisements/new",
        name: "AdvertisementsNew",
        component: AdvertisementsNew,
      },
      {
        path: "/advertisements/edit/:id",
        name: "AdvertisementsEdit",
        component: AdvertisementsEdit,
      },
    ],
  },
  {
    path: "/tiktoks",
    name: "Tiktoks",
    component: Layout,
    children: [
      {
        path: "/tiktoks",
        name: "Tiktoks",
        component: Tiktoks,
      },
      {
        path: "/tiktoks/new",
        name: "TiktoksNew",
        component: TiktoksNew,
      },
      {
        path: "/tiktoks/edit/:id",
        name: "TiktoksEdit",
        component: TiktoksEdit,
      },
    ],
  },
  {
    path: "/pricing",
    name: "Pricing",
    component: Layout,
    children: [
      {
        path: "/pricing",
        name: "pricing",
        component: Pricing,
      },
      {
        path: "/pricing/edit/:id",
        name: "PricingEdit",
        component: PricingEdit,
      },
    ],
  },
  {
    path: "/titles-subtitles",
    name: "TitlesSubtitlesLayout",
    component: Layout,
    children: [
      {
        path: "/titles-subtitles",
        name: "TitlesSubtitles",
        component: TitlesSubtitles,
      },
      {
        path: "/titles-subtitles/edit/:id",
        name: "TitlesSubtitlesEdit",
        component: TitlesSubtitlesEdit,
      },
    ],
  },
  {
    path: "/ugc-creators",
    name: "UGCCReators",
    component: Layout,
    children: [
      {
        path: "/ugc-creators",
        name: "UGCCReators",
        component: UGCCReators,
      },
      {
        path: "/ugc-creators/edit/:id",
        name: "UGCCReatorsEdit",
        component: UGCCreatorsEdit,
      },
      {
        path: "/ugc-creators/new",
        name: "UGCCReatorsNew",
        component: UGCCreatorsNew,
      },
    ],
  },
  {
    path: "/customers",
    name: "Customers",
    component: () =>
      import(/* webpackChunkName: "Customers" */ "../layouts/index.vue"),
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    children: [
      {
        path: "/customers/",
        name: "CustomersAll",
        component: () =>
          import(
            /* webpackChunkName: "CustomersAll" */ "../views/Customers/All.vue"
          ),
      },
      {
        path: "/customers/:id",
        name: "Customers",
        component: () =>
          import(
            /* webpackChunkName: "CustomersId" */ "../views/Customers/Id.vue"
          ),
      },
      {
        path: "/customers/new",
        name: "CustomersNew",
        component: () =>
          import(
            /* webpackChunkName: "CustomersNew" */ "../views/Customers/new.vue"
          ),
      },
      {
        path: "/customers/edit/:id",
        name: "CustomersEdit",
        component: () =>
          import(
            /* webpackChunkName: "CustomersEdit" */ "../views/Customers/Edit.vue"
          ),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Initialize PostHog
const { posthog } = usePostHog();

// Track pageviews on route changes
router.afterEach((to) => {
  posthog.capture('$pageview', {
    $current_url: window.location.href,
    path: to.path,
    name: to.name,
  });
});

export default router;
